import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

export const NewsCard = ({
                             title,
                             image,
                             description,
                             date,
                             category
                         }: {
    title: string;
    image: string;
    description: string;
    date: string;
    category: string;
}) => {
    const navigate = useNavigate();

    return (
        <div className={styles.card} onClick={() => navigate(`/neuigkeiten/${title.toLowerCase()}`)}>
            {image && <img src={image} alt={title} className={styles.image} />}
            <div className={styles.content}>
                <div className={styles.header}>
                    <span className={styles.category}>{category}</span>
                    <span className={styles.date}>{date}</span>
                </div>
                <h2 className={styles.title}>{title}</h2>
                <p
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                        __html: description.replace(/\n\n/g, "<br /><br />")
                    }}
                />
                <button
                    className={styles.read_more_button}
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/neuigkeiten/${title.toLowerCase()}`);
                    }}
                >
                    Mehr Lesen
                </button>
            </div>
        </div>
    );
};
